export class PMOTagSearchDataModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class PMOTag extends PMOTagSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
